// src/components/CookieBanner/CookieBanner.jsx
// GDPR-compliant cookie consent banner.
// Shows on first visit, disappears after choice.
// Wires to driverCookie.js accept/decline helpers.

import { useState, useEffect } from "react";
import { hasDecidedConsent, acceptConsent, declineConsent } from "./DriverSlice/Drivercookie";
import "../styles/Cookiebanner.css";

export default function CookieBanner({ onDecision }) {
  const [visible, setVisible] = useState(false);
  const [detail, setDetail] = useState(false);

  useEffect(() => {
    // Small delay so banner doesn't flash before React hydrates
    const t = setTimeout(() => {
      if (!hasDecidedConsent()) setVisible(true);
    }, 800);
    return () => clearTimeout(t);
  }, []);

  const accept = () => {
    acceptConsent();
    setVisible(false);
    onDecision?.("accepted");
  };

  const decline = () => {
    declineConsent();
    setVisible(false);
    onDecision?.("declined");
  };

  if (!visible) return null;

  return (
    <div className={`vk-cookie-banner${visible ? " visible" : ""}`} role="dialog" aria-label="Cookie consent">
      <div className="vk-cookie-inner">
        <div className="vk-cookie-header">
          <span className="vk-cookie-logo">VK</span>
          <span className="vk-cookie-eyebrow">// COOKIE NOTICE</span>
        </div>

        <p className="vk-cookie-body">
          We use cookies to remember your driver profile and preferences across sessions.
          No data is sold or shared with third parties.
        </p>

        {detail && (
          <div className="vk-cookie-detail">
            <div className="vk-cookie-detail-row">
              <span className="vk-cookie-detail-name">vk_driver_profile</span>
              <span className="vk-cookie-detail-desc">Stores your registration status, callsign, grid code, and avatar. Expires 365 days. Functional.</span>
            </div>
            <div className="vk-cookie-detail-row">
              <span className="vk-cookie-detail-name">vk_cookie_consent</span>
              <span className="vk-cookie-detail-desc">Records your consent choice. Expires 365 days. Essential.</span>
            </div>
          </div>
        )}
 
        <button className="vk-cookie-toggle" onClick={() => setDetail(d => !d)}>
          {detail ? "▲ LESS INFO" : "▼ MORE INFO"}
        </button>

        <div className="vk-cookie-actions">
          <button className="vk-cookie-btn vk-cookie-btn--accept" onClick={accept}>
            ACCEPT &amp; CONTINUE ▶
          </button>
          <button className="vk-cookie-btn vk-cookie-btn--decline" onClick={decline}>
            ESSENTIAL ONLY
          </button>
        </div>

        <p className="vk-cookie-policy">
          By accepting, you agree to our{" "}
          <a href="/privacy">Privacy Policy</a>.
          You can change your preference at any time.
        </p>
      </div>
    </div>
  );
}